import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'
import * as R from 'ramda'
import { PermissionArea, Text } from '@pbt/pbt-ui-components'

import { getCRUDByArea } from '~/store/reducers/auth'
import type { BasePracticeDetailsSectionProps } from '~/types'

import ContinuousMigration from './continuousMigrationV2/ContinuousMigration'
import Mappings from './migrationV2/Mappings'
import CatalogAndSettings from './practiceCloning/CatalogAndSettings'

const MigrationSectionV2 = ({
  business,
  isRhapsodyAnalytics = false,
}: BasePracticeDetailsSectionProps & { isRhapsodyAnalytics: boolean }) => {
  const { t } = useTranslation('Businesses')
  const businessId = business.id
  const permissions = useSelector(getCRUDByArea(PermissionArea.IMPORT))

  return (
    <Grid>
      {permissions.create && (
        <Grid container direction="column" mt={2} pl={6}>
          <Text mb={1} ml={-3} variant="h4">
            {t('Businesses:MIGRATION.CONTINUOUS_MIGRATION')}
          </Text>
          <ContinuousMigration businessId={businessId} />
        </Grid>
      )}
      {permissions.read && !isRhapsodyAnalytics && (
        <Grid container direction="column" mt={2} pl={6}>
          <Text mb={1} ml={-3} variant="h4">
            {t('Businesses:MIGRATION.RELATIONS_MAPPINGS')}
          </Text>
          <Mappings businessId={businessId} />
        </Grid>
      )}
      {!isRhapsodyAnalytics && (
        <Grid container direction="column" mt={2} pl={6}>
          <Text mb={1} ml={-3} variant="h4">
            {t('Businesses:MIGRATION.PRACTICE_CATALOG_AND_SETTINGS')}
          </Text>
          <CatalogAndSettings businessId={businessId} />
        </Grid>
      )}
    </Grid>
  )
}

export default memo(MigrationSectionV2, (prevProps, nextProps) =>
  R.equals(prevProps.business, nextProps.business),
)
